let componentsData: any;

try {
  componentsData = require('../../../../dist/components_json.json');
} catch (error) {
  console.warn('components_json.json non trouvé. Utilisation de valeurs par défaut.');
  componentsData = {};
}

import { Meta, StoryFn } from '@storybook/web-components';
import { withComponentControls } from '@utils/utils';

const elementTag = 'spw-table';

const argTypes = {
  ...withComponentControls(componentsData, { tag: elementTag }),
};

const meta: Meta = {
  title: 'Composants/Tableau',
  component: elementTag,
  argTypes,
  tags: ['autodocs'],
  parameters: {
    docs: {
      description: {
        component: `
Affiche toutes les informations d’un ensemble de données.

[<spw-link>Consulter la documentation</spw-link>](https://zeroheight.com/2310c7a1e/p/90a77b-tableau)
        `,
      },
    },
  },
};

export default meta;

function htmlContent() {
  return /* HTML */ `
    <spw-table-head>
      <spw-table-row>
        <spw-table-header scope="col">Header 1</spw-table-header>
        <spw-table-header scope="col">Header 2</spw-table-header>
        <spw-table-header scope="col">Header 3</spw-table-header>
        <spw-table-header scope="col">Header 4</spw-table-header>
      </spw-table-row>
    </spw-table-head>
    <spw-table-body>
      <spw-table-row>
        <spw-table-cell>Cellule</spw-table-cell>
        <spw-table-cell>Cellule</spw-table-cell>
        <spw-table-cell>Cellule</spw-table-cell>
        <spw-table-cell>Cellule</spw-table-cell>
      </spw-table-row>
      <spw-table-row>
        <spw-table-cell>Cellule</spw-table-cell>
        <spw-table-cell>Cellule</spw-table-cell>
        <spw-table-cell>Cellule</spw-table-cell>
        <spw-table-cell>Cellule</spw-table-cell>
      </spw-table-row>
      <spw-table-row>
        <spw-table-cell colspan="2" vertical-align="middle" text-align="center"
          >Cellule avec contenu plus long centré verticalement et horizontalement pour montrer la fusion</spw-table-cell
        >
        <spw-table-cell>Cellule</spw-table-cell>
        <spw-table-cell>
          <spw-button size="small">Bouton</spw-button>
        </spw-table-cell>
      </spw-table-row>
      <spw-table-row>
        <spw-table-cell>Cellule</spw-table-cell>
        <spw-table-cell>Cellule</spw-table-cell>
        <spw-table-cell>Cellule</spw-table-cell>
        <spw-table-cell>Cellule</spw-table-cell>
      </spw-table-row>
      <spw-table-row>
        <spw-table-cell>Cellule</spw-table-cell>
        <spw-table-cell>Cellule</spw-table-cell>
        <spw-table-cell>Cellule</spw-table-cell>
        <spw-table-cell>Cellule</spw-table-cell>
      </spw-table-row>
      <spw-table-row>
        <spw-table-cell>Cellule</spw-table-cell>
        <spw-table-cell>Cellule</spw-table-cell>
        <spw-table-cell>Cellule</spw-table-cell>
        <spw-table-cell>Cellule</spw-table-cell>
      </spw-table-row>
    </spw-table-body>
  `;
}

function camelToKebab(str: string) {
  return str.replace(/[A-Z]/g, match => `-${match.toLowerCase()}`);
}

const Template: StoryFn = args => {
  const element = document.createElement(elementTag);

  const masterProps = Object.keys(withComponentControls(componentsData, { tag: elementTag }) || {});

  Object.entries(args).forEach(([key, val]) => {
    if (masterProps.includes(key)) {
      const kebabKey = camelToKebab(key);
      element.setAttribute(kebabKey, val);
    } else if (key.startsWith('on')) {
      element.addEventListener(key.substring(2).toLowerCase(), val);
    }
  });

  element.innerHTML = htmlContent();

  return element;
};

export const Default = Template.bind({});
Default.args = {};
